export default __webpack_public_path__ + "static/developer-8f59f88161687770dde56b5de5a06737.webp";